import { render, staticRenderFns } from "./academyKeywords.vue?vue&type=template&id=5c61c80b&"
import script from "./academyKeywords.vue?vue&type=script&lang=js&"
export * from "./academyKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports